import { render, staticRenderFns } from "./videoAnalysis.vue?vue&type=template&id=3f682fdd&"
import script from "./videoAnalysis.vue?vue&type=script&lang=js&"
export * from "./videoAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports